import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import { ClarityConsentGate } from './components/ClarityConsentGate.tsx';
import { PreviewCheckoutPage } from './components/PreviewCheckoutPage';

/**
 * Modo preview (`/preview/:checkoutNanoId`): usado pelo iframe de prévia ao vivo do admin.
 * Decidido aqui, fora de `App.tsx`, pra não misturar hooks/estado do fluxo normal de oferta
 * com o fluxo de prévia (produto fake + `postMessage`).
 */
function Root() {
  const pathSegments = window.location.pathname.split('/').filter((p) => p !== '');
  if (pathSegments.length >= 2 && pathSegments[0] === 'preview') {
    const checkoutNanoId = decodeURIComponent(pathSegments[1] || '');
    return <PreviewCheckoutPage checkoutNanoId={checkoutNanoId} />;
  }

  return (
    <>
      <App />
      <ClarityConsentGate />
    </>
  );
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Root />
  </StrictMode>,
);
